import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { JJUnicorn_Video1 } from '../../../../../utils/EN/Modals/aiArtists';

const ModalVideoJJUnicorn1 = () => {
  return (
    <>
      <ModalVideo
        id="jj-unicorn-video-1"
        dataText={JJUnicorn_Video1}
        videoSrc="https://www.youtube.com/"
        videoTitle="KUTER_STUDIO_AI_JJUNICORN_VIDEO_1"
      />
    </>
  );
};

export default ModalVideoJJUnicorn1;
